/**
 * This handles adding new smartgateway
 */
export class SmartGateway {
  public description: string;
  public apiKey: string;
  public domain: string;
  public plantID: number;
  public serialNumber: string;
  public smartGatewayReadingInterval: number;

  constructor(smartgateway: any) {
    if (smartgateway) {
      Object.assign(this, smartgateway);
    }
  }
}
